import * as React from 'react';

// #region Component Props 

interface IProps {
    onClick         : any;
    text            : string;
    buttonClasses?  : string;
    icon?           : string;
}

// #endregion

const DialogTrigger : React.SFC<IProps> = (props) => {

    const { icon, buttonClasses, text, onClick } = props;

    const hasIcon = icon ? true : false;
    const classList = (hasIcon ? 'btn-icon ' : 'btn ') + buttonClasses;

    return <button 
        className={ classList } 
        onClick={ onClick }>
        { hasIcon ? <i className={"la " + icon }/> : '' }
        { text }
    </button>;

};

DialogTrigger.defaultProps = {
    buttonClasses: '',
    icon: ''
};

export { DialogTrigger };
